<template>
  <div>
    <!-- <template v-if="!callStarted">
      <div class="img" style="margin-top:144px"></div>
      <p class="title">您可点击右侧号码拨号</p>
      <p class="describe">话机已链接</p>
    </template>
    <template v-else> -->
    <div class="img" :style="{'margin-top':'20px','margin-bottom':clues?'20px':'10px'}"></div>
    <p class="title" v-if="callstatus==0">
      <span style="line-height:23px;">正在呼叫</span>
    </p>
    <p class="title" v-else>
      <span v-show="callstatus==1" style="line-height: 23px;">通话中...</span>
      <span v-show="callstatus==2" style="line-height: 23px;">通话结束</span>
      <span style="line-height:23px;">{{showTime}}</span>
    </p>
    <div class="btns">
      <button class="left" :class="{'hq-left':HQ}" @click="callAgain" v-if="callstatus==2">重拨</button>
      <button class="left" :class="{'hq-left':HQ}" @click="hangUp" v-else>挂断</button>
      <el-tooltip :content="disabledNext?'按卡片顺序拨打':'已拨打至最后一个'" placement="bottom" class="right" v-if="callLast||disabledNext">
        <button class="right last" :class="{'hq-right':HQ}">拨打下一个</button>
      </el-tooltip>
      <el-tooltip content="按卡片顺序拨打" placement="bottom" class="right" v-else>
        <button class="right" :class="{'hq-right':HQ}" @click="callNext">拨打下一个</button>
      </el-tooltip>
    </div>
    <div class="info">
      <p class="title">
        <el-tooltip effect="dark" :content="callName" placement="bottom" :disabled="callName&&callName.length<5">
          <span>{{callName&&callName.length>4?callName.substring(0,4)+'...':callName}}</span>
        </el-tooltip> 
        {{callNum}}
      </p>
      <el-tooltip :content="callCom" placement="bottom" :disabled="callCom.length<14" class="name">
        <span class="comName" v-if="path=='/sea'||path=='/task'||path=='/recycle'">
          <gem-link :href="'/report/' + callInfo.pid+'?company='+callCom+'&source='+path.split('/')[1]" :html="callCom"></gem-link>
        </span>
        <span class="comName" v-else>{{callCom}}</span>
      </el-tooltip>
    </div>
    <div class="from">
      <div class="content">
        <el-input resize="none" maxlength="500" type="textarea" :autosize="{ minRows:clues?7:6,maxRows: clues?7:6}" v-model.trim="note" placeholder="请写下想要记录的事情..."></el-input>
        <p class="count">
          <span>{{note.length}}</span>/500</p>
      </div>
      <div class="btn">
        <button :class="['cancel',{disabled:callstatus!=2}]" v-if="path=='/sea'||path=='/task'||path=='/pool'||(callInfo.type=='market'&& isAddedClue==1)" @click="deleteClue">删除线索</button>
        <button :class="['cancel',{disabled:callstatus!=2}]" v-else @click="closeCall">关闭弹窗</button>
      </div>
      <div class="btn">
        <button :class="['save',{'hq-save':HQ},{disabled:callstatus!=2}]" v-if="path=='/pool'||(callInfo.type=='market'&& isAddedClue==1)||isAdded==1" @click="saveNote">保存跟进</button>
        <button :class="['save',{'hq-save':HQ},{disabled:callstatus!=2}]" v-else @click="saveClue">保存并添加线索</button>
      </div>
    </div>
    <!-- </template> -->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { eventHub } from "../../common/utils.js";
export default {
  props: ["clues"],
  data () {
    return {
      note: "",
      callNum: "",
      callName: "",
      callCom: "",
      path: "",
      timer: "",
      timerId: "",
      callTimerId: "",
      callstatus: 0,
      calltime: 0,
      callFlag: true,
      showTime: "00:00:00",
      isConnected: false,
      isFree: false,
      message1: "",
      callLast: false,
      isAdded: null,
      cid: "",
      oldIsAddedClue: null,
      sourceName: null,
      dbName: null,
      disabledNext: false,
      isHighVersion:false,
    };
  },
  computed: {
    ...mapState({
      callStarted: state => state.callInfo.callStarted,
      callInfo: state => state.callInfo.callInfo,
      callStatus: state => state.callInfo.callStatus,
      updateName: state => state.callInfo.updateName,
      isAddedClue: state => state.callInfo.reportObj.isAddedClue,
      isCluePoolName:state=>state.account.isCluePoolName,
    }),
    noteNum () {
      return this.note.trim().length;
    }
  },
  watch: {
    callStarted () {
      this.note = "";
    },
    isAddedClue (val, oldVal) {
      if (oldVal != null) {
        this.oldIsAddedClue = oldVal
      }
    },
    callInfo (val, oldVal) {
      if (val && oldVal) {


        /* 不同的企业点击拨号清除备注 */
        if (val.pid != oldVal.pid) {
          /* 点击联系方式保存跟进内容 */
          if (this.note && this.oldIsAddedClue == 1) {
            this.saveNote(false, false, oldVal.pid);
          }
          this.note = ''
        } else {
          if (this.note && this.oldIsAddedClue == 1) {
            this.saveNote(false);
          }
        }
      }
      if (val) {
        let telList = [];
        for (let index = 0; index < val.telList.length; index++) {
          telList.push(val.telList[index].value);
        }
        this.callNum = val.tel.value;
        this.dbName = val.telList[0].dbName;
        this.sourceName = val.telList[0].sourceName;
        this.callName = val.tel.contact ? val.tel.contact : "-";
        this.callCom = val.entname;
        this.path = val.path;
        this.cid = val.cid;
        this.callstatus = 0;
        // this.note = "";
        this.callLast =
          telList.indexOf(val.tel.value) == val.telList.length - 1;
        this.isAdded = this.isAddedClue;
        this.showTip = true;
        this.calltime = 0;
        this.$store.commit("setCloseCard", false);
        // console.log(this.path);
      }
    },
    calltime (val) {
      if (val) {
        let secondTime = parseInt(val),
          minuteTime = 0,
          hourTime = 0;
        if (secondTime > 59) {
          minuteTime = parseInt(secondTime / 60);
          secondTime = parseInt(secondTime % 60);
          if (minuteTime > 59) {
            hourTime = parseInt(minuteTime / 60);
            minuteTime = parseInt(minuteTime % 60);
          }
        }
        secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
        minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
        hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
        this.showTime = hourTime + ":" + minuteTime + ":" + secondTime;
      } else {
        this.showTime = "00:00:00";
      }
    },
    callStatus (val) {
      // console.log(val);
      if (val) {
        this.checkCallStatus();
        if (this.note) {
          if (
            this.path == "/pool" ||
            (this.callInfo.type == "market" && this.isAddedClue == 1) ||
            this.isAdded == 1
          ) {
            this.saveNote(false);
          }
        }
        this.$store.commit("setCallStatus", "");
      }
    },
    isConnected (val) {
      if (val) {
        this.connectionFree();
      }
    },
    callstatus (val) {
      eventHub.$emit("callstatus", val);
      this.$store.commit("setCommonCallStatus", val);
      if (val == 2) {
        this.$store.commit("setCallStatus", "");
      }
    },
    isFree (val) {
      if (val) {
        this.startCall();
      }
    }
  },
  methods: {
    /*关闭弹窗*/
    closeCall () {
      if (this.callstatus != 2) {
        return;
      }
      this.$store.commit("setCallInfo", "");
      this.$store.commit("setThread", false);
      if (window.location.pathname == this.path) {
        // this.$store.commit("setUpdateName", this.path.replace('/',''));
        if (
          this.path != "/sea" &&
          this.path != "/recycle" &&
          this.path != "/pool" &&
          this.path != '/task'
        ) {
          this.$store.commit("setUpdateName", "report");
        }
      }
    },
    /*删除线索*/
    async deleteClue () {
      if (this.callstatus != 2) {
        return;
      }
      try {
        let updateName = "";
        if (this.path == "/sea" || this.path == "/task") {
          if (window.location.pathname == this.path) {
            updateName = this.path == "/sea" ? "sea" : "task";
          }
          await this.apiData("post", "recycle/addRecycle", {
            pid: this.callInfo.pid,
            from: this.path == "/task" ? "task" : ''
          });
        } else {
          if (window.location.pathname == this.path) {
            updateName = this.path == "/pool" ? "pool" : "report";
          }
          await this.apiData("post", "clue/deleteClue", {
            pids: [this.callInfo.pid]
          });
        }
        if (updateName) {
          this.$store.commit("setUpdateName", updateName);
        }
        this.$message.success("删除成功");
        this.$store.commit("setCloseCard", true);
        this.closeCall();
      } catch (error) {
        if (error.error_code == 6007) {
          this.$message.error("该线索已被其他用户处理");
          this.isAdded = 2;
        } else {
          this.$message.error(this.errorCode[error.error_code]);
        }
      }
    },
    /*保存并添加线索*/
    async saveClue () {
      if (this.callstatus != 2) {
        return;
      }
      try {
        let from = "";
        let updateName = "";
        if (this.path == "/sea") {
          from = "gonghai";
          updateName = window.location.pathname == this.path ? "sea" : "";
        } else if (this.path == "/recycle") {
          from = "recycle";
          updateName = window.location.pathname == this.path ? "recycle" : "";
        } else if (this.path == "/task") {
          from = "task";
          updateName = window.location.pathname == this.path ? "task" : "";
        } else {
          from = "market";
          updateName = window.location.pathname == this.path ? "report" : "";
        }
        await this.apiData("post", "clue/addClue", {
          pid: this.callInfo.pid,
          contacts: this.callNum,
          text: this.note,
          cid: this.cid,
          contactsType: this.sourceName,//接口更改
          dbname: this.dbName,
          from: from,
        });
        if (updateName) {
          this.$store.commit("setUpdateName", updateName);
        }
        // console.log(updateName);
        this.note = "";
        this.$message.success(`添加成功！您可以在${this.isCluePoolName?this.isCluePoolName:'我的线索'}版块查看`);
        let result = await this.apiData("get", "clue/checkClueAdded", {
          pid: this.callInfo.pid
        });
        this.isAdded = result.isAddedClue;
        this.$store.commit("setCloseCard", true);
        this.closeCall();
      } catch (error) {
        if (error.error_code == 6007) {
          this.$message.error("该线索已被其他用户处理");
          this.isAdded = 2;
        } else {
          this.$message.error(this.errorCode[error.error_code]);
        }
      }
    },
    /*保存跟进*/
    async saveNote (mode = true, cid, pid) {
      if (!cid && (this.callstatus != 2 || !this.note)) {
        return;
      }
      try {
        const result = await this.apiData("post", "clue/addTrailNote", {
          pid: pid ? pid : this.callInfo.pid,
          text: this.note,
          cid: cid ? cid : this.cid,
          action: 2
        });
        mode ? this.$message.success("保存成功") : "";
        if (this.isAddedClue == 1) {
          eventHub.$emit("isConfirm", false);
          eventHub.$emit("refreshTrailNoteList", 1);
        }
        this.note = "";
        // this.closeCall();
      } catch (error) {
        if (error.error_code == 6007) {
          this.$message.error("该线索已被其他用户处理");
          this.isAdded = 2;
        } else {
          this.$message.error(this.errorCode[error.error_code]);
        }
      }
    },
    /*查询状态*/
    checkCallStatus () {
      if (this.timerId) {
        window.clearInterval(this.timerId);
      }
      this.isHighVersion = false;
      this.timerId = window.setInterval(() => {
        this.getCallStatus();
      }, 2000);
    },
    getCallStatus () {
      let now = new Date().getTime() + Math.random();
      window["getFree"] = res => {
        // console.log('3',this.isHighVersion)
        if((res.data.local_ver<'20190925') && !this.isHighVersion ){
          this.$message.warning('您的电话助手版本过低，请尽快更新至最新版本，以免影响使用');
          this.isHighVersion = true;
        }
        if (res.data.status == "call_out") {
          this.callstatus = 0;
        } else if (res.data.status == "talking") {
          this.callstatus = 1;
          if (this.callFlag) {
            this.calltime = 0;
            this.getCallTime();
            this.callFlag = false;
          }
        } else if (res.data.status == "hangup") {
          this.callstatus = 2;
          window.clearInterval(this.timerId);
          window.clearInterval(this.callTimerId);
          // console.log("clear");
          this.callFlag = true;
        }
        window["getFree"] = null;
      };
      let url =
        "https://localhost:10081/JD_get_status?_=" + now + "&callback=getFree";
      this.fetchJsonp(url);
      this.removeEle("connect");
    },
    getCallTime () {
      if (this.callTimerId) {
        window.clearInterval(this.callTimerId);
      }
      this.callTimerId = window.setInterval(() => {
        this.calltime++;
      }, 1000);
    },
    /*拨打下一个*/
    async callNext () {
      const _selt = this;
      _selt.disabledNext = true
      setTimeout(() => {
        _selt.disabledNext = false
      }, 3000);
      let index = 0;
      this.callInfo.telList.forEach((e, i) => {
        if (e.value == this.callNum) {
          index = i + 1;
        }
      });
      this.callLast = index == this.callInfo.telList.length - 1;
      if (index < this.callInfo.telList.length) {
        this.callNum = this.callInfo.telList[index].value;
        this.dbName = this.callInfo.telList[index].dbName;
        this.sourceName = this.callInfo.telList[index].sourceName;
        this.callName = this.callInfo.telList[index].contact
          ? this.callInfo.telList[index].contact
          : "-";
        await this.hangUp();
        /* 同步跟进记录 */
        if (this.isAddedClue == 1) {
          eventHub.$emit("refreshTrailNoteList", 1);
        }
        this.callAgain();
      } else {
        this.callLast = true;
      }
    },
    /*挂断*/
    hangUp () {
      if (this.callstatus != 2) {
        this.callstatus = 2;
        let now = new Date().getTime() + Math.random();
        window["hangUp"] = res => {
          window.clearInterval(this.timerId);
          window.clearInterval(this.callTimerId);
          this.callFlag = true;
          window["hangUp"] = null;
        };
        let url =
          "https://localhost:10081/JD_call_end?_=" + now + "&callback=hangUp";
        this.fetchJsonp(url);
        this.removeEle("connect");
      }
    },
    /*重新呼叫*/
    async callAgain () {
      try {
        let result = await this.apiData("get", "clue/checkClueAdded", {
          pid: this.callInfo.pid
        });
        /*若填写了跟进记录保存跟进记录 */
        if (this.note) {
          if (
            this.path == "/pool" ||
            (this.callInfo.type == "market" && this.isAddedClue == 1) ||
            this.isAdded == 1
          ) {
            this.saveNote(false);
          } /* else {
            this.saveClue();
          } */
        }
        if (result.isAddedClue == 0 || result.isAddedClue == 1) {
          // console.log("callAgain");
          this.callstatus = 0;
          this.calltime = 0;
          // this.callLast = false;
          this.isAdded = result.isAddedClue;
          await this.getConnectStatus();
        } else {
          this.$message.error("该线索已被其他用户处理");
          this.isAdded = result.isAddedClue;
        }
      } catch (error) {
        if (error.error_code == 6007) {
          this.$message.error(error.error_code.message);
          // this.$message.error("该线索已被其他用户处理");
          this.isAdded = 2;
        } else {
          this.$message.error(this.errorCode[error.error_code]);
        }
      }
    },
    getConnectStatus () {
      let conMessage = this.$message({
        message: "正在连接中...",
        type: "success",
        duration: 6000
      });
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        conMessage.close();
        this.$message.error("连接失败。请检查设备是否正常连接");
      }, 4000);
      try {
        let now = new Date().getTime() + Math.random();
        this.isHighVersion = false;
        window["getConnected"] = res => {
          window.clearTimeout(this.timer);
          conMessage.close();
          if (res.data.connect_status == 1) {
            this.isConnected = true;
            this.message1 = this.$message.success("连接成功");
          } else {
            this.isConnected = false;
            this.message1 = this.$message.error(
              "连接失败。请检查设备是否正常连接"
            );
          }
          window["getConnected"] = null;
        };
        let url =
          "https://localhost:10081/JD_get_connect_status?_=" +
          now +
          "&callback=getConnected";
        this.fetchJsonp(url);
        this.removeEle("connect");
      } catch (error) {
        conMessage.close();
        this.$message.error("连接失败。请检查设备是否正常连接");
        return;
      }
    },
    connectionFree () {
      this.isConnected = false;
      let now = new Date().getTime() + Math.random();
      window["getFree"] = res => {
        // debugger
        // console.log('4')
        // if((res.data.local_ver<'20190925') && !this.isHighVersion){
        //   this.$message.warning('您的电话助手版本过低，请尽快更新至最新版本，以免影响使用');
        //   this.isHighVersion = true;
        // }
        if (res.data.status == "hangup") {
          this.isFree = true;
        } else {
          this.isFree = false;
          this.message1.close();
          this.$message.warning("设备正在使用中，无法拨号。");
        }
        window["getFree"] = null;
      };
      let url =
        "https://localhost:10081/JD_get_status?_=" + now + "&callback=getFree";
      this.fetchJsonp(url);
      this.removeEle("connect");
    },
    startCall () {
      this.message1.close();
      this.isFree = false;
      let now = new Date().getTime() + Math.random();
      let token = this.getItem("local", "twe_logged");
      this.cid = this.getUuid();
      let callSource = this.path.split('/')[1];
      if (token) {
        window["getcall"] = res => {
          if (res.code == 0) {
            // if (!res.connect_status) {
            //   this.RegistCall();
            //   this.$message.error("连接失败。请检查设备是否正常连接");
            // } else {
              this.checkCallStatus();
              if (this.path != "/sea" && this.path != "/recycle") {
                this.addTrailNote(this.callInfo.pid, this.cid).then(resp => {
                  // console.log(resp);
                });
              }
            // }
          } else {
            this.$message.error("呼叫失败");
          }
          window["getcall"] = null;
        };
        token = token.split(" ")[1];
        let Origin = this.getOrigin();
        let url =
          "https://localhost:10081/JD_call_start?_=" +
          now +
          "&callback=getcall" +
          "&tel_number=" +
          this.callNum +
          "&pushurl=" +
          Origin +
          "/api/callRecord/receiveCallRecord?token=" +
          token +
          "&contact=" +
          encodeURIComponent(encodeURIComponent(this.callName)) +
          "&cid=" +
          this.cid +
          "&pid=" +
          this.callInfo.pid +
          "&company=" +
          encodeURIComponent(encodeURIComponent(this.callCom)) +
          '&callSource=' + callSource;
        this.fetchJsonp(url);
        this.removeEle("connect");
      } else {
        this.$message.error("用户未登录");
      }
    },
    fetchJsonp (url) {
      let body = document.getElementsByTagName("body")[0];
      let script = document.createElement("script");
      script.setAttribute("src", url);
      script.setAttribute("id", "connect");
      body.appendChild(script);
    },
    removeEle (id) {
      let body = document.getElementsByTagName("body")[0];
      let ele = document.getElementById(id);
      body.removeChild(ele);
    }
  }
};
</script>
<style lang="scss" scoped>
.img {
  width: 112px;
  height: 112px;
  text-align: center;
  line-height: 112px;
  border-radius: 3px;
  margin: 144px auto 30px;
  // background-color: #e2f3f3;
  background-image: url("../../assets/small.png");
  background-position: center center;
  background-repeat: no-repeat;
}
.title {
  font-size: 20px;
  color: #333;
  text-align: center;
  height: 25px;
}
.describe {
  font-size: 14px;
  color: #66bb6a;
  margin-top: 10px;
  text-align: center;
}
.btns {
  text-align: center;
  margin-top: 20px;
  button {
    font-size: 14px;
    color: #fff;
    outline: none;
    border: none;
    cursor: pointer;
  }
  .left {
    width: 90px;
    height: 34px;
    border-radius: 2px;
    background-color: var(--warning-color);
    margin-right: 10px;
    &.hq-left {
      background-color: #fef9f9;
      border: 1px solid #f1afaf;
      color: #e15151;
      &:hover {
        background-color: #fef9f9;
        border: 1px solid #f75353;
        color: #f75353;
      }
    }
  }
  .right {
    width: 90px;
    height: 34px;
    border-radius: 2px;
    background-color: var(--theme-color);
    &.hq-right {
      color: #fff;
      background: #e15151;
      &:hover {
        background: #f75353;
      }
    }
  }
  .last {
    background: #dddddd;
    color: #999;
    cursor: not-allowed;
  }
}
.info {
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 15px 20px;
  margin-top: 20px;
  .name {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 10px;
    display: block;
  }
}
.from {
  .count {
    text-align: right;
    padding: 0px 20px;
    color: #555;
    font-size: 12px;
    border-bottom: 1px solid #ececec;
    padding-bottom: 5px;
    span {
      color: #999;
    }
  }
  .btn {
    padding: 0 20px;
    margin-top: 10px;
  }
  button {
    width: 100%;
    border-radius: 2px;
    background-color: #dddddd;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    outline: none;
    border: none;
    &.cancel {
      background: #c6cbd0;
      color: #fff;
      &:hover {
        background: #b3b8bd;
      }
    }
    &.save {
      background: var(--theme-color);
      color: #fff;

      &:hover {
        background: #3db3b3;
      }
      &.hq-save {
        color: #fff;
        background: #e15151;
        &:hover {
          background: #f75353;
        }
      }
    }
    &.disabled {
      pointer-events: none;
      background-color: #dddddd;
      color: #999;
      cursor: not-allowed;
      &:hover {
        background: #dddddd;
      }
    }
  }
}
</style>
<style lang="scss">
.from {
  .content {
    .el-textarea__inner {
      border: none;
      height: 160px;
      padding: 10px 20px;
      &:focus {
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/callSub.vue